'use client';

import React from 'react';

interface RoundedButtonProps {
  label: string;
  onClick: () => void;
  className?: string;
  disabled?: boolean;
  style?: React.CSSProperties;
}

const RoundedButton = ({ label, onClick, disabled, className, style }: RoundedButtonProps) => {
  return (
    <button className={`${className}`} onClick={onClick} disabled={disabled} style={style}>
      {label}
    </button>
  );
};

export default RoundedButton;
